module.exports = __webpack_public_path__ + "img/science-title.77719a19.png";